import { render, staticRenderFns } from "./ProfessionTest.vue?vue&type=template&id=47a595f3&scoped=true&"
import script from "./ProfessionTest.vue?vue&type=script&lang=js&"
export * from "./ProfessionTest.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionTest.vue?vue&type=style&index=0&id=47a595f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a595f3",
  null
  
)

export default component.exports